<!-- 价格信息 -->
<template>
  <div class="price-info">
    <el-form :model="queryParams" :rules="rules" ref="BusinessInfoForm">
      <el-form-item label="产品价格：" label-width="140px">
        <el-input
          v-model="queryParams.productPrice"
          type="number"
          style="width: 470px;"
        />
      </el-form-item>

      <el-form-item label="产品价格范围：" label-width="140px">
        <el-input
          v-model="queryParams.productPriceRange"
          style="width: 470px;"
        />
      </el-form-item>

      <el-form-item label="价格单位：" label-width="140px">
        <el-input v-model="queryParams.priceUnit" style="width: 470px;" />
      </el-form-item>

      <el-form-item label="税率：" label-width="140px">
        <el-input v-model="queryParams.taxRate" style="width: 470px;" />
      </el-form-item>

      <el-form-item label="币种:" label-width="140px">
        <el-radio-group v-model="queryParams.currency">
          <el-radio
            v-for="(item, index) in query.judgeArray"
            :key="index"
            :label="item.label"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>

      <el-form-item label="价格说明：" label-width="140px">
        <el-input
          v-model="queryParams.priceDescription"
          style="width: 470px;"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// api
import { findPriceInfo, updatePriceInfo } from "@/api/product.js";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      queryParams: {
        currency: "", // 币种
        priceDescription: "", // 价格说明
        priceUnit: "", // 价格单位
        productCode: "", // 主键
        productPrice: "", // 产品价格
        productPriceRange: "", // 产品价格范围
        taxRate: "" // 税率
      },
      rules: {},
      query: {
        judgeArray: [
          {
            label: "美元"
          },
          {
            label: "人民币"
          },
          {
            label: "港元"
          }
        ]
      }
    };
  },
  methods: {
    getInfo() {
      findPriceInfo({ productCode: this.$route.query.productCode }).then(
        res => {
          if (res.code == 200) {
            this.queryParams = res.data;
          }
        }
      );
    },
    submit() {
      if (!this.queryParams.productCode) {
        this.queryParams.productCode = this.$route.query.productCode;
      }

      updatePriceInfo(this.queryParams).then(res => {
        if (res.code == 200) {
          this.$message.success("编辑成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
